import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import { Icon } from '@/ui/common/icon';

export interface KreditBetConnectedBarProps {
  onDismiss?: () => void;
  className?: string;
}

/** Figma KreditBetConnectedBar — status under Place bet when creditor is linked. */
export function KreditBetConnectedBar({ onDismiss, className }: KreditBetConnectedBarProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'flex w-full items-center justify-between overflow-hidden rounded-lg border-[1.5px] border-action-primary bg-bg-surface px-3 py-2.5',
        className,
      )}
    >
      <div className="flex min-w-0 flex-1 items-center gap-2.5 overflow-hidden">
        <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-action-primary text-text-on-action">
          <Icon name="creditbetin" size={16} className="text-text-on-action" />
        </div>
        <p className="truncate text-[13px] font-bold text-text-primary">
          {t('ConnectedWithCreditbet', { defaultValue: 'Connected With KreditBet' })}
        </p>
      </div>
      <button
        type="button"
        aria-label={t('Remove', { defaultValue: 'Remove' })}
        onClick={onDismiss}
        className="shrink-0 text-text-primary hover:opacity-80"
      >
        <Icon name="close" size={16} />
      </button>
    </div>
  );
}
